<template>
  <div v-if="item" class="py-2 px-8" @click.stop>
    <v-divider />
    <v-row v-if="item.size">
      <v-col cols="11">
        Review:&nbsp;&nbsp;
        <v-btn-toggle dense mandatory v-model="sel">
          <v-btn small>Daily</v-btn>
          <v-btn small>Total</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <h4>INCOME</h4>
        <v-simple-table dense>
          <slot :item="item" v-if="sel === 0 &&!item.dealWithHalving" name="income" />
          <slot :item="item" v-if="sel === 0 &&item.dealWithHalving" name="income-with-halving" />
          <slot :item="item" v-if="sel === 1" name="income-total" />
        </v-simple-table>
        <v-divider />
        <h4>COST</h4>
        <v-simple-table dense>
          <slot :item="item" v-if="sel === 0 &&!item.dealWithHalving" name="cost" />
          <slot :item="item" v-if="sel === 0 &&item.dealWithHalving" name="cost-with-halving" />
          <slot :item="item" v-if="sel === 1" name="cost-total" />
        </v-simple-table>
        <v-divider/>
        <h4>PROFIT</h4>
        <v-simple-table dense>
          <slot :item="item" v-if="sel === 0 &&!item.dealWithHalving" name="profit" />
          <slot :item="item" v-if="sel === 0 &&item.dealWithHalving" name="profit-with-halving" />
          <slot :item="item" v-if="sel === 1" name="profit-total" />
        </v-simple-table>
      </v-col>
      <v-col cols="12" sm="6" style="background: #FCFBF4;">
        <div v-if="item.dealWithHalving"><span class="font-weight-bold">Block Reward Halving Date:</span><span> {{blockchain[item.coin].halvingTs | date}}</span></div>
        <h4 v-if="item.size">Profitability Metrics</h4>
        <v-simple-table v-if="item.size" dense class="detailTable">
          <tr><td>ROI</td><td><colored :value="item.total.roi" format="percent" :digits="1" /></td></tr>
          <tr><td>Breakeven Days</td><td><colored :value="item.breakevenDays" format="breakeven" /></td></tr>
          <tr><td>Discount</td><td><colored :value="item.discount" format="percent" :digits="1" /></td></tr>
          <tr><td>Cost Basis</td><td>{{item.costBasis | price('USD', 2)}}</td></tr>
        </v-simple-table>
        <h4>DETAILS</h4>
        <v-simple-table dense class="detailTable">
          <tr><td>Guaranteed Uptime</td><td>{{issuer.guaranteedUptime}}</td></tr>
          <tr v-if="item.contract_size"><td>Minimal Amount</td><td>{{item.contract_size}}{{item.coin === 'ETH' ? 'M' : 'T'}}</td></tr>
          <tr><td>Delivery Time</td><td>{{deliveryTime}}</td></tr>
        </v-simple-table>
        <div class="my-2"></div>
        <h4>PAYMENT</h4>
        <v-simple-table dense class="detailTable">
          <!--          <tr><td>Payment Term</td><td>Pay as you go/ Pay all upfront / Set and forget???</td></tr>-->
          <tr><td>Accepted Payment</td><td><pre>{{issuer.acceptedPayment}}</pre></td></tr>
          <tr><td>Payout Type</td><td><pre>{{issuer.payout && issuer.payout.replace('$coin', item.coin)}}</pre></td></tr>
          <!--          <tr><td>Referral</td><td>???</td></tr>-->
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Colored from "@/components/Colored";
import { price, date } from "@/filters";

export default {
  name: "ProductDetail",
  components: { Colored },
  filters: { price, date },
  props: ["item"],
  computed: {
    ...mapState(["blockchain"]),
    issuer() { return this.$store.state.issuers.data[this.item.issuers || this.item.issuer] || {}; },
    deliveryTime() { return this.item.id.endsWith('_futures') ? this.issuer.deliveryTimeFutures : this.issuer.deliveryTime }
  },
  data() {
    return {
      sel: this.item && this.item.size ? 1 : 0
    };
  }
}
</script>

<style scoped>
.v-data-table {
  background-color: unset!important;
}

pre {
  font-family: inherit!important;
}

.v-data-table--dense >>> th {
  font-size: 13px;
}

.v-data-table--dense >>> td {
  height: 24px;
  width: 50%;
}

.detailTable{
  background-color: transparent;
}

.v-item--active {
  color: #222;
  background-color: #ffe500 !important;
}
</style>